import { render, staticRenderFns } from "./HolidaysRequests.vue?vue&type=template&id=346f515d&scoped=true&"
import script from "./HolidaysRequests.vue?vue&type=script&lang=ts&"
export * from "./HolidaysRequests.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "346f515d",
  null
  
)

export default component.exports